import { ProcessModel } from "./ProcessModel";

export class ProcessStarterActivityModel {
	id?: number = undefined;
	idProcess?: number = undefined;
	isActive: boolean = false;
	name: string = '';
	description: string|null = null;
	initiator: boolean = false;
	info: string|null = null;
	finisher: boolean = false;
	nextActivities: number[] = [];
	dueTimeHours: number = 0;
	process: ProcessModel = new ProcessModel();

	constructor(p?: Partial<ProcessStarterActivityModel>) {
		Object.assign(this, p)

		this._parseProcess()
	}

	private _parseProcess():void {
		this.process = new ProcessModel(this.process)
	}
}
